"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _Icon = _interopRequireDefault(require("../Icon"));

var _constants = require("./constants");

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HeaderButton(_ref) {
  var type = _ref.type,
      to = _ref.to,
      ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, to ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: to,
    className: "header__button"
  }, type && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: type
  }), children && /*#__PURE__*/_react.default.createElement("span", null, children)) : /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    name: type,
    className: (0, _utils.getClassNames)(className, 'header__button'),
    onClick: onClick,
    "aria-label": ariaLabel
  }, type && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: type
  }), children && /*#__PURE__*/_react.default.createElement("span", null, children)));
}

HeaderButton.propTypes = {
  type: _propTypes.default.oneOf(_constants.HEADER_ICONS_TYPE),
  to: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func
};
HeaderButton.defaultProps = {
  type: null,
  to: null,
  ariaLabel: null,
  className: undefined,
  children: null,
  onClick: function onClick() {}
};
var _default = HeaderButton;
exports.default = _default;